import React from 'react';
import cover from './EIDEFUT1.png';

const Navigation = () => {
	return (
		<div className="container">
			<img className="cover" alt="Cancha de fútbol sala Eidefut" src={cover} />
		</div>
	)
}

export default Navigation;